import { Select } from 'antd';
import { useQuery } from '@tanstack/react-query';
import { SizeType } from 'antd/es/config-provider/SizeContext';
import { IReceiptNo, IReceiptNoReq, IReceiptNoRes } from '@/interfaces/misc';
import { AxiosResponse } from 'axios';
import { searchReceiptNo } from '@/adapters/misc';
import { useEffect, useState } from 'react';

interface IProps {
  disabled?: boolean;
  value?: string;
  receiptNo?: IReceiptNo;
  size?: SizeType;
  isAll?: boolean;
  handleSelectData: (receiptNo: IReceiptNo) => void;
  readonly?: boolean;
  customClass?: string;
  allowClear?: boolean;
  dateFrom?: string;
  dateTo?: string;
}

const _criteria: IReceiptNoReq = {
  dateFrom: undefined,
  dateTo: undefined,
};

const ReceiptNoSelector = ({
  disabled = false,
  value,
  size = 'large',
  handleSelectData,
  isAll = false,
  readonly = false,
  receiptNo,
  customClass,
  allowClear = true,
  dateFrom,
  dateTo,
}: IProps) => {
  const [criteria, setCriteria] = useState<IReceiptNoReq>({
    ..._criteria,
    dateFrom,
    dateTo,
  });

  useEffect(() => {
    setCriteria((prev) => ({
      ...prev,
      dateFrom,
      dateTo,
    }));
  }, [dateFrom, dateTo]);

  const { data: receiptNos, isLoading } = useQuery<
    AxiosResponse<IReceiptNoRes>,
    Error
  >({
    queryKey: ['search-receipt-no', criteria],
    queryFn: async () => await searchReceiptNo(criteria),
  });

  let groupOptions =
    receiptNos?.data?.data?.map((g) => {
      return {
        value: `${g.ID}`,
        label: `${g.ID}`,
      };
    }) || [];

  const allOptions = [{ value: '', label: 'ทั้งหมด' }, ...groupOptions];

  const onChange = (value: string) => {
    const receiptNoInfo = receiptNos?.data?.data?.find((d) => d.ID === value);
    handleSelectData(receiptNoInfo as IReceiptNo);
  };

  if (receiptNo) groupOptions = [...groupOptions];
  return (
    <Select
      allowClear={allowClear}
      showSearch
      loading={isLoading}
      value={value}
      className={customClass}
      size={size}
      placeholder="เลือกเลขที่ใบเสร็จ"
      onChange={(value) => onChange(value)}
      onClear={() => onChange('')}
      options={isAll ? allOptions : [...groupOptions]}
      filterOption={(input, option) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
      }
      disabled={readonly || isLoading || disabled}
    />
  );
};

export default ReceiptNoSelector;
